/**
 * Blog slugs published on flogpt.in.
 *
 * An en-IN alternate is only valid when that URL is a real post. flogpt.in
 * has none today, so the list is empty and blog pages emit no hreflang.
 * Add a slug here only after the post is published on the India site — the
 * India sitemap lists a post only when that deployment's database has it.
 */
export const INDIA_BLOG_SLUGS: readonly string[] = [];

export const blogPostExistsOnIndia = (slug: string | undefined): boolean =>
    !!slug && INDIA_BLOG_SLUGS.includes(slug);

/** True while flogpt.in has no posts, so `/blogs` must not be indexed or alternated. */
export const indiaBlogIndexNoindex = (): boolean =>
    import.meta.env.VITE_SITE_REGION === "in" && INDIA_BLOG_SLUGS.length === 0;

/** Reciprocal hreflang for `/blogs` only after at least one India post exists. */
export const blogIndexInHreflangCluster = (): boolean => INDIA_BLOG_SLUGS.length > 0;
